const Color = {
    white: "#ffffff",
    black: "#222222",
    sapphire100: "rgba(5, 102, 141, 1)",
    sapphire80: "rgba(5, 102, 141, 0.8)",
    sapphire60: "rgba(5, 102, 141, 0.6)",
    green100: "rgba(0, 168, 150, 1)",
    green80: "rgba(0, 168, 150, 0.8)",
    green60: "rgba(0, 168, 150, 0.6)",
    grey100: "rgba(152, 152, 152, 1)",
    grey80: "rgba(152, 152, 152, 0.8)",
    grey60: "rgba(152, 152, 152, 0.6)",
    blue100: "rgba(25, 170, 227, 1)",
    blue80: "rgba(25, 170, 227, 0.8)",
    blue60: "rgba(25, 170, 227, 0.6)",
    red100: "rgba(240, 52, 10, 1)",
    red80: "rgba(240, 52, 10, 0.8)",
    red60: "rgba(240, 52, 10, 0.6)",
  };
  
export default Color;